import React from 'react';
import {Col, Label, Row} from 'reactstrap';
import {AvGroup} from 'availity-reactstrap-validation';
import {Button} from 'reactstrap';
import PropTypes from 'prop-types';
import AvField from "../../shared/component/form/AvField";
import Translate from "../../shared/language/Translate";
import {Fieldset} from "primereact/fieldset";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import ProductService from "../../shared/service/ProductService";
import {InputNumber} from "primereact/inputnumber";
import {STOCK_EVENT, STOCK_EVENT_ADD_REASON, STOCK_EVENT_DROP_REASON} from "../../shared/utils/Constants";


const defaultProduct = {
    id: '',
    name: '',
    status: 'ACTIVE',
    barcode: '',
    minStock: null,
    maxStock: null,
    currentStock: null,
    stockOperation: '',
    stockOperationReason: '',

};
export default class StockSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            product: Object.assign({}, defaultProduct),
            productDetailsSaveButtonRender: true,
        }
        this.productService = new ProductService();
    }

    componentDidMount() {

    }

    clearData = () => {
        this.setState({
            product: Object.assign({}, defaultProduct),
        });

    }
    setData = (data) => {
        this.setState({
            product: Object.assign({}, data),
        });
    }


    render() {
        return (<div className="p-col-12">
            <Fieldset legend={"Add/Drop Stock"}>
                <Row>
                    <Col md="4">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate contentKey="producttradingName">Barcode</Translate>
                            </Label>
                            <AvField
                                type="number"
                                className="form-control"
                                name="barcode"
                                disabled={true}
                                max="99999999999999"
                                value={this.state.product.barcode}
                                onChange={this.__handleChange}/>


                        </AvGroup>
                    </Col>

                    <Col md="4">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate contentKey="producttradingName">Name</Translate>
                            </Label>
                            <AvField
                                type="text"
                                className="form-control"
                                name="name"
                                disabled={true}
                                value={this.state.product.name}
                                onChange={this.__handleChange}/>


                        </AvGroup>
                    </Col>

                    <Col md="4">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate contentKey="producttradingName">Current Stock</Translate>
                            </Label>
                            <AvField
                                name="currentStock"
                                type={"number"}
                                disabled={true}
                                value={this.state.product.currentStock}
                                onChange={this.__handleChange}
                                className="table-responsive"
                            />
                        </AvGroup>
                    </Col>

                </Row>
                <Row>


                    <Col md="4">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate contentKey="producttradingName">Min Stock</Translate>
                            </Label>
                            <AvField
                                type={"number"}
                                name="minStock"
                                disabled={!this.state.productDetailsSaveButtonRender}
                                value={this.state.product.minStock}
                                onChange={this.__handleChange}
                                className="table-responsive"
                            />
                        </AvGroup>
                    </Col>

                    <Col md="4">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate contentKey="producttradingName">Max Stock</Translate>
                            </Label>
                            <AvField
                                type={"number"}
                                name="maxStock"
                                disabled={!this.state.productDetailsSaveButtonRender}
                                value={this.state.product.maxStock}
                                onChange={this.__handleChange}
                                className="table-responsive"
                            />
                        </AvGroup>
                    </Col>

                    <Col md="4">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate contentKey="producttradingName">Stock Operation</Translate>
                            </Label>
                            <AvField
                                type="select"
                                className="form-control"
                                name="stockOperation"
                                disabled={!this.state.productDetailsSaveButtonRender}
                                value={this.state.product.stockOperation}
                                onChange={this.__handleChange}>
                                <option value='' key=''/>
                                {STOCK_EVENT.map(element => (
                                    <option value={element.value} key={element.value}>
                                        {element.name}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </Col>

                    {this.state.product.stockOperation == "ADD_STOCK" &&
                        <Col md="4">
                            <AvGroup>
                                <Label for="tradingName">
                                    <Translate contentKey="producttradingName">Stock Operation
                                        Reason</Translate>
                                </Label>
                                <AvField
                                    type="select"
                                    className="form-control"
                                    name="stockEventReason"
                                    disabled={!this.state.productDetailsSaveButtonRender}
                                    value={this.state.product.stockEventReason}
                                    onChange={this.__handleChange}>
                                    {STOCK_EVENT_ADD_REASON.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>))}
                                </AvField>
                            </AvGroup>
                        </Col>
                    }

                    {this.state.product.stockOperation == "DROP_STOCK" &&
                        <Col md="4">
                            <AvGroup>
                                <Label for="tradingName">
                                    <Translate contentKey="producttradingName">Stock Operation
                                        Reason</Translate>
                                </Label>
                                <AvField
                                    type="select"
                                    className="form-control"
                                    name="stockEventReason"
                                    disabled={!this.state.productDetailsSaveButtonRender}
                                    value={this.state.product.stockEventReason}
                                    onChange={this.__handleChange}>
                                    {STOCK_EVENT_DROP_REASON.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>))}
                                </AvField>
                            </AvGroup>
                        </Col>
                    }


                    <Col md="4">
                        <AvGroup>
                            <Label for="tradingName">
                                <Translate contentKey="producttradingName">Stock</Translate>
                            </Label>
                            <AvField
                                name="stock"
                                type={"number"}
                                disabled={!this.state.productDetailsSaveButtonRender}
                                value={this.state.product.stock}
                                onChange={this.__handleChange}
                                className="table-responsive"
                            />
                        </AvGroup>
                    </Col>


                </Row>

                {!GeneralUtils.isNullOrEmpty(this.state.product.id) && GeneralUtils.checkPrivilege("post_product/product") && this.state.productDetailsSaveButtonRender &&
                    <Button color="outline-primary" style={{marginRight: '5px'}} onClick={() => {
                        this.updateStock();
                    }}>
                        <Translate contentKey="entity.action.add">Save Stock</Translate>
                    </Button>
                }


                <Button color="outline-primary" style={{marginRight: '5px'}} onClick={() => {
                    this.props.closeDisplayDialog();
                }}>
                    <Translate contentKey="entity.action.add">Close</Translate>
                </Button>
            </Fieldset>
        </div>)
            ;
    }

    updateStock = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.product.id)) {
            this.productService.updateStock(this.state.product)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            product: response,
                        });
                        this.props.refreshDataTable();
                    }
                });
        }

    }


    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let product = this.state.product;
        product[e.target.name] = value;
        if (e.target.name == "stockOperation") {
            if (value == "ADD_STOCK") {
                product['stockOperationReason'] = "DELIVERY";
            } else if (value == "DROP_STOCK") {
                product['stockOperationReason'] = "EXPIRED";
            } else {
                product['stockOperationReason'] = "";
            }
        }
        this.setState({product: product});
    }


}

StockSave.propTypes = {
    order: PropTypes.object
};
